export const ReturnRules={
    data:{
        baseTitle:'رویه های بازگردانی کالا',
        baseText:`در چه شرایطی میتوانم کالای خود را بازگردانم؟
آسودگی خاطر و رضایت مندی مشتریان همواره از الویت‏‌های لوکسین لوکس  بوده است و لوکسین لوکس  در این راستا می‏‌کوشد تا هر سفارش در شرایط مطلوب و مورد انتظار به دست مشتری برسد. با وجود این ممکن است مشتریان محترم پس از خرید، با مسائلی روبرو شوند که درچنین مواردی خدماتی در چارچوب خدمات پس از فروش در نظر گرفته شده است.
گروه‌های کالای ارایه شده در وب‌سایت لوکسین لوکس ، کلیه محصولاتی که باید از نظر فیزیکی سالم به دست مصرف کننده برسند )مانند کالاهای گروه‌  دکوراسیون، مد و پوشاک و کفش، لوازم خانگی ، عطر و ادکلن، زیورآلات و اکسسوری، لوازم آرایشی و بهداشتی و مراقبت، دارای گارانتی اصالت و سلامت فیزیکی هستند و مشمول 2 روز مهلت تست و بازگشت کالا نمی‌شوند. همچنین اقلامی که به عنوان هدیه‌ از طرف لوکسین لوکس  همراه سفارش ارسال و در فاکتور فروش با مبلغ صفر ریال درج شده‌اند، مشمول 2 روز ضمانت بازگشت نیستند. برای سایر محصولاتی که نیاز به مهلت تست دارند، لوکسین لوکس ، 2 روز فرصت برای بازگشت درنظر گرفته است.
لطفاً توجه داشته باشید:`,
        alert:'باز کردن جعبه و نصب کالاهایی که باید توسط نصاب شرکت مربوط راه اندازی شوند، تنها باید توسط نصاب مجاز انجام شود. برای این منظور با شرکت مربوط یا نمایندگی مجاز آن تماس بگیرید. در غیر این صورت امکان استفاده از هرگونه گارانتی یا خدمات پس از فروش از بین خواهد رفت. ',
        allTitles:[
            {
                id:0,
                title:'شرایط بازگرداندن کالا',
                textTitle:'استفاده از2  روز ضمانت بازگشت چه شرایطی دارد؟ ',
                reason:[
                    {
                        title:'اگر کالای خریداری شده، ایراد یا اشکال فنی داشته باشد:',
                        listT:[
                            {
                                id: 1,
                                text:'اشکال و یا ایراد فنی باید حداکثر تا 2 روز پس از دریافت کالا، به لوکسین لوکس اطلاع داده شود.'
                            },
                            {
                                id: 2,
                                text:'لازم است کارتن و جعبه اصلی محصولات تا پایان 2 روز مهلت استفاده، نگهداری شود و از دور ریختن آن جداً خودداری شود.'
                            },
                            {
                                id: 3,
                                text:'اشکال و یا ایراد فنی باید حداکثر تا 2 روز پس از دریافت کالا، به لوکسین لوکس اطلاع داده شود.'
                            },
                            {
                                id: 4,
                                text:'استفاده از این سرویس تنها در صورتی امکان‌پذیر است که کالا در کارتن یا جعبه اصلی خود به لوکسین لوکس بازگردانده شود.'
                            },
                            {
                                id: 5,
                                text:'برچسب‌زدن یا نوشتن توضیحات، آدرس یا هر مورد دیگری روی کارتن یا جعبه اصلی کالا و یا پاره و مخدوش کردن آن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد.'
                            },
                            {
                                id: 6,
                                text:'این سرویس اشکال‏‏‌های فنی و ظاهری (شکستگی، خط و خش و مانند آن روی بدنه کالا و قطعات تزئینی) که در اثر استفاده نادرست کاربر از کالا ایجاد شود، را شامل نمی‏‏‌شود. استفاده نادرست پس از تحویل کالا مواردی مانند حمل و نقل و جابجایی، نصب و راه‌اندازی، تنظیمات، کاربرد غیرمعمول، نگهداری و استفاده‌ی غیر و متفاوت با توصیه سازنده کالا (قید شده در دفترچه راهنمای کالا) را شامل می‌شود.'
                            },
                        ],
                    },
                    {
                        title:'اگر کالای خریداری شده از نظر مشخصات یا ظاهر فیزیکی با اطلاعات وب‌سایت مغایرت داشته باشد:',
                        listT:[
                            {
                                id: 1,
                                text:'وجود مغایرت یا کسری اقلام همراه کالا ، باید حداکثر طی 24 ساعت پس از دریافت کالا، به واحد خدمات پس از فروش لوکسین لوکس از طریق تلفن یا ایمیل اطلاع داده شود.'
                            },
                            {
                                id: 2,
                                text:'اگر مغایرت، بدون استفاده از کالا قابل مشاهده است، مثل رنگ یا مشخصات درج شده روی بدنه، باید کالا در شرایط اولیه خود باشد و از آن استفاده نشده باشد.'
                            },
                            {
                                id: 3,
                                text:'عکس محصولات جهت اطلاع و کمک به خرید مشتری است و از آنجا که ممکن است در پاره ای جزییات با کالای اصلی تفاوت هایی داشته باشد به استناد آن‌ها نمی‌توان اعلام مغایرت کرد. ملاک وجود مغایرت در مشخصات کالا، مشخصات فنی درج شده در وب‌سایت است.'
                            },
                            {
                                id: 4,
                                text:'در صورتی که امکان تشخیص مغایرت، بدون باز کردن بسته‌بندی وجود دارد، امکان رسیدگی به درخواست مشتری در صورتی ممکن است که کالا از حالت اورجینال یا بسته‌بندی اصلی و اولیه خود خارج نشده باشد.'
                            },
                            {
                                id:5,
                                text:'در صورتی که امکان تشخیص مغایرت و کسری اقلام همراه تنها با باز کردن بسته‌بندی ممکن باشد، لازم است کارتن و جعبه اصلی محصولات نگهداری شود و از دور ریختن آن جداً خودداری شود.'
                            },
                        ],
                        lastText:'استفاده از این سرویس تنها در صورتی امکان‌پذیر است که کالا در کارتن یا جعبه اصلی خود به لوکسین لوکس  بازگردانده شود. برچسب‌زدن یا نوشتن توضیحات، آدرس یا هر مورد دیگری روی کارتن یا جعبه اصلی کالا و یا پاره و مخدوش‌کردن آن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد.'
                    },
                    {
                        title:'اگر کالای خریداری شده، آسیب دیدگی یا ایراد فیزیکی و ظاهری داشته باشد:',
                        listT:[
                            {
                                id: 1,
                                text:' آسیب‏‏ یا ایراد فیزیکی باید حداکثر طی 24 ساعت پس از دریافت کالا، به خدمات پس از فروش لوکسین لوکس از طریق ارسال پیام توسط کاربر در پنل کاربری ، تلفن یا ایمیل اطلاع داده شود.'
                            },
                            {
                                id: 2,
                                text:' لازم است کارتن و جعبه اصلی محصولات نگهداری شود و از دور ریختن آن جداً خودداری شود. استفاده از این سرویس تنها در صورتی امکان‌پذیر است که کالا در کارتن یا جعبه اصلی خود به لوکسین لوکس بازگردانده شود. برچسب‌زدن یا نوشتن توضیحات، آدرس یا هر مورد دیگری روی کارتن یا جعبه اصلی کالا و یا پاره و مخدوش کردن آن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد.'
                            },
                        ]
                    },
                    {
                        title:'اگر مشتری از خرید خود منصرف شود:',
                        listB:[
                            {
                                id: 1,
                                text:'توجه بند 1: انصراف از خرید و درخواست مرجوعی به کالایی تعلق می‌گیرد که باز نشده باشد، هیچ‌گونه دخل و تصرف، باز کردن بسته‌بندی اولیه، پلمب، برچسب‌ها و حتی نایلون وکیوم و شیرینک، امکان مرجوع کردن را از بین خواهد برد حتی اگر از کالا استفاده نشده باشد.'
                            },
                            {
                                id: 2,
                                text:' توجه بند 2: از آنجا که لوکسین لوکس یک وب‌سایت فروشی آنلاین است، حق استرداد کالا طبق شرایط صرفا متعلق به مشتری یا همان مصرف‌کننده است ( سفارش یک کالا به تعداد، مغایر با هدف مصرف خریدار است و شامل حق استرداد نمی‌شود).'
                            },
                        ],
                        listT:[
                            {
                                id: 1,
                                text:'اگر هنوز سفارش توسط فروشنده ارسال نشده باشد، باید هر چه سریع‏‌تر به واحد پیگیری سفارش‌های لوکسین لوکس (شماره تلفن 88147559 - 021) اطلاع داده شود.'
                            },
                            {
                                id: 2,
                                text:' اگر پس از دریافت کالا مشتری از خرید خود منصرف شود، حداکثر تا 2 روز‏، باید انصراف خود را به واحد خدمات پس از فروش اطلاع دهد.'
                            },
                            {
                                id: 3,
                                text:'با استناد به “توجه بند 1” در این حالت، برگرداندن کالا پس از تایید کارشناس خدمات پس از فروش، تنها در صورتی امکان‌پذیر است که کالا باز نشده باشد، در شرایط اولیه خود (پلمپ) باشد، از آن استفاده نشده باشد، و به همراه همه ملزومات و اقلام همراه آن، ارسال شود. همچنین اگر کالا به‌ همراه هدیه فروخته شده باشد، بازگرداندن هدیه همراه آن نیز الزامی است. لازم به ذکر است کالاهایی که به دلیل ماهیت خاص یا استفاده شخصی و با توجه به لزوم رعایت مسایل بهداشتی نمی‌توانند بازپس داده شوند، از شمول این بند خارج هستند.'
                            },
                        ],
                        lastText:'لطفاً توجه داشته باشید که هرگونه تغییر در شرایط اولیه کالا، حتی در بسته‌بندی امکان استفاده از این سرویس را از بین خواهد برد. همچنین در صورت انصراف از خرید، ارسال کالا به عهده مشتری خواهد بود.'
                    },
                    {
                        title:' اگر در اثر حمل و نقل، آسیب دیدگی ایجاد شده باشد:',
                        listT:[
                            {
                                id: 1,
                                text:'آسیب‏‏ دیدگی باید حداکثر طی 24 ساعت پس از دریافت کالا، به خدمات پس از فروش لوکسین لوکس اطلاع داده شود.'
                            },
                            {
                                id: 2,
                                text:'با توجه به بسته‌بندی ایمن و استاندارد همه مرسولات، تحویل به هر یک از شرکت‏‏‌های حمل و نقل معتبر و اعلام بارنامه مرسوله به این معنی است که بروز هر گونه حادثه در هنگام حمل و تحویل به عهده شرکت حمل و نقل است و لوکسین لوکس تنها در صورت تایید شرکت حمل کننده سفارش و در راستای تسهیل امور پیگیری، خسارت را جبران می‌‏کند.'
                            },
                            {
                                id: 3,
                                text:'لازم است کارتن و جعبه اصلی محصولات نگهداری شود و از دور ریختن آن جداً خودداری شود. استفاده از این سرویس تنها در صورتی امکان‌پذیر است که کالا در کارتن یا جعبه اصلی خود به لوکسین لوکس بازگردانده شود. برچسب‌زدن یا نوشتن توضیحات، آدرس یا هر مورد دیگری روی کارتن یا جعبه اصلی کالا و یا پاره و مخدوش کردن آن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد.'
                            },
                            {
                                id: 4,
                                text:'کالای آسیب دیده و همه لوازم جانبی و متعلقات آن، باید به همان شکلی که مشتری تحویل گرفته است به همراه صورت جلسه رسمی شرکت حمل کننده و فاکتور به خدمات پس از فروش لوکسین لوکس ارسال شود.'
                            },
                            {
                                id: 5,
                                text:'در صورتی که آسیب‏‌، در لحظه قابل مشاهده باشد، مشتری می‏‌تواند از تحویل‌گرفتن مرسوله خودداری کند تا جهت بررسی و ارسال مجدد به لوکسین لوکس بازگردانده شود.'
                            },
                        ],
                        lastText:'پس از بررسی کالاهای مرجوعی توسط کارشناسان خدمات پس از فروش، در صورتی که کالا خارج از ضوابط مقرر در سایت مرجوع شده باشد و بدون ایراد تشخیص داده شود، برای مشتری ارسال می‌شود. در صورت استنکاف مشتری از تحویل کالای سالم و بدون ایراد، کالای مزبور به مدت یک ماه بصورت امانت نزد لوکسین لوکس در واحد خدمات پس از فروش باقی می‌ماند و با انقضای این مهلت لوکسین لوکس در قبال کالا و زیان‌های وارده بر آن یا مفقود شدن آن هیچ‌گونه مسئولیتی نخواهد داشت.'
                    }
                ],

            },
            {
                id: 1,
                title: 'ضوابط و مسئولیت‌های مربوط به فروش پوشاک و کفش',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'به دلیل رعایت نکات بهداشتی و شخصی و طبیعت خاص فروش اینگونه کالاها، این گروه شامل مهلت تست 2 روزه نیستند. بنابراین برای استفاده از گارانتی سلامت فیزیکی مشتری می‌پذیرد، در اولین فرصت و حداکثر تا 6 ساعت پس از دریافت کالا، درخواست خود را با ذکر شماره پیگیری سفارش، به خدمات پس از فروش لوکسین لوکس اطلاع دهد.'
                            },
                            {
                                id: 2,
                                text:'درخواست مرجوعی تنها در صورتی پذیرفته می‌شود که کفش یا پوشاک تنها تست شده باشند و در وضعیت اولیه و نو باشند، و روی پوشاک هیچگونه آثار استفاده مانند لکه، رنگ‌پریدگی یا بوی عطر و بدن وجود نداشته باشد، و مارک، دکمه و سایر ملحقات جدا نشده باشد. (توجه شود لباس زیر، مایو و لباس کودک و نوزاد شامل برگشت کالا نمی شوند.)'
                            },
                        ],
                    },]
            },
            {
                id: 2,
                title: 'ضوابط و مسئولیت‌های مربوط به گروه فرش',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'در صورت ارسال کالا توسط فروشنده، لازم است مشتری در حضور مامور تحویل سفارش، سلامت فیزیکی کالا را بررسی و در صورت وجود مشکل یا ایراد از تحویل‌گرفتن آن خودداری کند. بدیهی است که تحویل گرفتن کالا توسط مشتری به منزله تایید سلامت فیزیکی آن خواهد بود.'
                            },
                            {
                                id: 2,
                                text:'در صورت وجود ایراد در کالایی که توسط فروشنده تحویل داده شده است، مشتری موظف است همان روز نسبت به بازگرداندن آن اقدام کند. هرگونه درخواستی از طرف مشتری تنها پس از تایید و اعلام نظر کارشناسان لوکسین لوکس و کارشناسان شرکت تامین کننده قابل پیگیری خواهد بود.)'
                            },
                        ],
                    },
                ]
            },
            {
                id: 3,
                title: 'موارد ابطال گارانتی',             
                textTitle:`محصولاتی که کارت ضمانت، بر چسب هولوگرام یا شماره سریال آن مخدوش شده و یا با شماره سریال دستگاه مطابقت ندارد شامل گارانتی نمی‌باشد.
ضمانت دستگاه، محدود به عیوب ناشی از ساخت بوده و شامل ایرادات ناشی از بلایای طبیعی یا حوادث غیر مترقبه، ضربه, آتش، نفوذ مایعات یا مواد شیمیایی، شکستگی، خراشیدگی، تغییر شکل، زنگ زدگی، نوسانات برق یا عیوب مربوط به استفاده در محیط های آلوده و پر گردوغبار ، تغییر در قطعات ، قطع و وصل اتصالات در حین روشن بودن دستگاه ،صدمات حین عمل, آسیب دیدگی کانکتور و کابل و استفاده نادرست از دستگاه و اتصال پورتهای ورودی و خروجی به برق شهر، بکارگیری آداپتورهای متفرقه ،استفاده نادرست (عدم رعایت شرایط مندرج در دستورالعمل نگهداری و کارکرد)، دستکاری، تنظیم یا تعمیر توسط افراد غیر مجاز نمی‌باشد.
آسیب های ناشی از نقص فنی ذاتی محصولات ، مواد بکار رفته در آن و شرایط تولید، تا تاریخ قید شده در کارت گارانتی شامل گارانتی می‌باشد.`,}
,
            {
                id: 4,
                title: 'کالا را چطور ارسال کنید؟',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'لطفاً قبل از هر اقدامی با کارشناسان پشتیبانی خدمات پس از فروش لوکسین لوکس، تماس بگیرید.'
                            },
                            {
                                id: 2,
                                text:'از ارسال کالا برای فروشنده، بدون هماهنگی با خدمات پس از فروش لوکسین لوکس جداً، خودداری کنید.'
                            },
                            {
                                id: 3,
                                text:'برای ارسال، باید کالا در جعبه یا کارتن اصلی خود به ‏خوبی بسته‌بندی شود و لوازم جانبی و همه اقلام همراه به همراه کالای اصلی ارسال شود.'
                            },
                            {
                                id: 4,
                                text:'برچسب‌زدن یا نوشتن توضیحات، آدرس یا هر مورد دیگری روی کارتن یا جعبه اصلی کالا و یا پاره و مخدوش کردن آن، امکان استفاده از ضمانت بازگشت را از بین خواهد برد. (در صورت لزوم، توضیحات خود را پشت فاکتور خرید یا قطعه کاغذ جداگانه‌ای بنویسید.)'
                            },
                            {
                                id: 5,
                                text:'درصورت ارسال با پست پیشتاز، عکس و تصویری از رسید پستی تهیه و به آدرس support@luxinlux.com ایمیل کنید.'
                            },
                            {
                                id: 6,
                                text:'اگر ساکن تهران هستید، برای هماهنگی ارسال پیک برای تحویل‌گرفتن کالا، با لوکسین لوکس تماس بگیرید.'
                            },
                            {
                                id: 7,
                                text:'از نوشتن آدرس روی جعبه یا کارتن اصلی کالا، جداً خودداری کنید و در صورت لزوم ، جعبه اصلی محصول را درون کارتن دیگری گذاشته، آن را ارسال کنید.'
                            },
                            {
                                id: 8,
                                text:'بسته خود را به آدرسی که از طریق کارشناسان خدمات پس از فروش لوکسین لوکس به شما ارسال میگردد، ارسال کنید.'
                            },
                        ],
                    },
                ]
            },
            {
                id: 5,
                title: 'هزینه ارسال چطور محاسبه خواهد شد؟',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'اگر ایراد فنی، وجود مغایرت فنی یا فیزیکی یا آسیب دیدگی ظاهری، به تایید کارشناسان خدمات پس از فروش لوکسین لوکس برسد، هزینه‌های ارسال به عهده فروشنده است.'
                            },
                            {
                                id: 2,
                                text:'برای واریز هزینه پست به حساب مشتری، قبض پستی با مهر شرکت پست باید همراه کالا به شرکت لوکسین لوکس ارسال شود. همچنین تصویری از رسید تهیه و به آدرس support @luxinlux.com .ایمیل شود.'
                            },
                            {
                                id: 3,
                                text:'در صورت انصراف از خرید، یا تایید نشدن ایراد یا مغایرت توسط کارشناسان هایپر بی جی، هزینه ارسال و دریافت مجدد کالا، به عهده مشتری خواهد بود.'
                            },
                        ],
                    },
                ]
            },
            {
                id: 5,
                title: 'پس از رسیدن و دریافت کالا توسط خدمات پس از فروش، روند رسیدگی به درخواست مشتری چگونه خواهد بود؟',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'کارشناسان خدمات پس از فروش لوکسین لوکس ایرادهای اعلام شده توسط مشتری را بررسی و کنترل می‌‏کنند. پس از بررسی موارد مطرح شده توسط کارشناسان لوکسین لوکس این ایرادها به فروشنده مورد نظر ارجاع و در صورت تایید ایراد کالا توسط فروشنده، وجه بحساب شما مرجوع میشود و در صورت عدم تایید ، کالا به شما بازگردانده میشود.'
                            },
                            {
                                id: 2,
                                text:'اتمام موجودی کالا و یا تغییرات قیمت کالا در مراحل کارشناسی و مرجوعی، به هیچ عنوان حقی را برای مشتری ایجاد نمی‌کند و لوکسین لوکس در قبال تهیه همان کالا و یا تغییرات قیمت کالا هیچ‌گونه تعهدی نداشته و فقط تعهد بازپرداخت وجه کالا -درج شده در فاکتور- به مشتری را می‌پذیرد.'
                            },
                            {
                                id: 3,
                                text:'پس از دریافت و پذیرش کالا توسط لوکسین لوکس، بسته به نوع محصول و مشکل اعلام شده توسط مشتری، تست و اعلام نظر نهایی کارشناسان خدمات پس از فروش، به طور میانگین 48 ساعت کاری زمان خواهد برد.'
                            },
                            {
                                id: 4,
                                text:'کارشناسان فنی خدمات پس از فروش برای تست محصولات، ملزم به رعایت استانداردها و دستورالعمل‌ها و رویه‌های ابلاغ شده توسط فروشندگان کالاهای ارائه شده در سایت لوکسین لوکس هستند، لذا علیرغم تصور آن‌که تست کالا (حتی برای ایرادهای خیلی آشکار) می‌تواند خیلی سریع انجام شود، ولی در عمل رعایت رویه‌های تست زمان‌بر است و در مواردی نیاز به هماهنگی با نمایندگی‌های مجاز آن کالا دارد. به همین علت زمان اعلام نظر کارشناسی برای تایید ایراد کالا ، به طور میانگین 48 ساعت کاری در نظر گرفته شده است، ولی خدمات پس از فروش لوکسین لوکس، تمام تلاش خود را بکار خواهد بست تا سرعت تست و کارشناسی را افزایش داده، در کوتاه‌ترین زمان ممکن به نیاز مشتریان محترم پاسخ دهد.پس از تایید ایراد کالا ، مرجوع  وجه طی 48 ساعت کاری صورت می پذیرد.'
                            },
                            {
                                id: 5,
                                text:'ملاک عمل و اقدام شرکت، نظر کارشناسان فنی پشتیبانی و خدمات پس از فروش لوکسین لوکس و کارشناسان فروشنده است.'
                            },
                        ],
                    },
                ]
            },
            {
                id: 6,
                title: 'چطور درخواست خود را جهت مرجوعی کالا به شما اطلاع دهم؟',
                textTitle:'از طریق یکی از روش‌های زیر، درخواست خود را اطلاع دهید:',
                reason:[
                    {
                        listT:[
                            {
                                id: 1,
                                text:'وارد پروفایل خود شوید و از قسمت درخواست مرجوعی ، درخواست خود را ثبت کنید.'
                            },
                            {
                                id: 2,
                                text:'یا پیام خود را در صفحه ارسال پیام در پنل کاربری، با انتخاب موضوع خدمات پس از فروش یا مرجوعی کالا، ارسال کنید.'
                            },
                            {
                                id: 3,
                                text:'با شماره تلفن 88147559-021 خدمات پس از فروش تماس بگیرید.'
                            },
                        ],
                    },
                ],
                lastText:`بدیهی است در صورت ثبت درخواست مرجوعی به صورت آنلاین، فرایند مرجوعی سریعتر انجام خواهد شد.
توجه: جهت رسیدگی به درخواست، ذکر شماره پیگیری سفارش در هر یک از روش‌های بالا الزامی است.
                `,
            } 
        ]

    }

}